import { onBeforeUnmount, onMounted, ref } from 'vue'
import { LIST_VIEW_MIN_WIDTH_PX } from '../constants/propertyView'

// True above the tablet breakpoint (992px). The properties screen swaps
// layouts here: list view and anchored popovers on desktop; cards and bottom
// sheets on tablet / phone.
export function useWideViewport() {
  const isWide = ref(true)
  let mediaQuery: MediaQueryList | null = null
  const sync = () => {
    isWide.value = mediaQuery?.matches ?? true
  }

  onMounted(() => {
    if (typeof window.matchMedia !== 'function') return
    mediaQuery = window.matchMedia(`(min-width: ${LIST_VIEW_MIN_WIDTH_PX + 1}px)`)
    sync()
    mediaQuery.addEventListener('change', sync)
  })

  onBeforeUnmount(() => {
    mediaQuery?.removeEventListener('change', sync)
    mediaQuery = null
  })

  return { isWide }
}
